import React from 'react'
import CommonHeroComponent from '../components/CommonHeroComponent/CommonHeroComponent'
import EventsNews from '../components/EventsNewsSection/EventsNews'
import EventGrid from '../components/EventsGrids/EventGrid'

const EventsPage = () => {
    return (
        <div>
            <CommonHeroComponent Heading="EVENTS" Para="" backgroundImg="/images/creatives/events-banner.jpg" />

            <EventsNews />
            <EventGrid />
        </div>
    )
}

export default EventsPage